import React from "react";
import PropTypes from "prop-types";
import StringField from "../../../common/form-field/StringField";

const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Invalid email address"
    : undefined;

const EmailField = ({ validate, ...props }) => {
  return <StringField validate={[...validate, email]} {...props} />;
};

EmailField.propTypes = {
  validate: PropTypes.array.isRequired,
};

export default EmailField;



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/components/Email.js